export type ComposeAmountAnchor = "send" | "receive";

/**
 * Resolves the send-leg amount to persist on the compose draft / mint payload.
 * Receive-anchored typing pins destination currency — never pass that number
 * through as `sendAmount`.
 */
export function resolveComposeSendAmount(input: {
  anchor: ComposeAmountAnchor;
  pinnedAmount: number;
  optionSendAmount?: number | null;
}): number {
  if (input.anchor === "receive") {
    return input.optionSendAmount ?? input.pinnedAmount;
  }
  return input.pinnedAmount;
}
